module.exports = __webpack_public_path__ + "resource/img/image047Dark.1d58a9c4.png";